import { useCallback, useState } from "react";
import { doc, updateDoc } from "firebase/firestore";
import { db } from "@/integrations/firebase/firestore";
import { logError } from "@/shared/services/ErrorReporting";

export function useUpdateAcquisitionStatus(jobId: string | undefined) {
  const [isUpdating, setIsUpdating] = useState(false);

  const updateAcquisitionStatus = useCallback(
    async (markedForDeletion: boolean): Promise<boolean> => {
      if (!jobId) return false;
      setIsUpdating(true);
      try {
        const jobRef = doc(db, "jobs", jobId);
        await updateDoc(jobRef, { marked_for_deletion: markedForDeletion });
        return true;
      } catch (err) {
        logError(err as Error);
        return false;
      } finally {
        setIsUpdating(false);
      }
    },
    [jobId],
  );

  return { updateAcquisitionStatus, isUpdating };
}
